;(function ($) {

    $('body')
        .on('click', '.office-profile__map-addresses__nav--left', function(e) {
            e.preventDefault();

            var $addresses = $('.office-profile__map-addresses__scroll');
            $addresses.animate({scrollLeft: ($addresses.scrollLeft() - 255)});
        })
        .on('click', '.office-profile__map-addresses__nav--right', function(e) {
            e.preventDefault();

            var $addresses = $('.office-profile__map-addresses__scroll');
            $addresses.animate({scrollLeft: ($addresses.scrollLeft() + 255)});
        })
        .on('click', '.js-show-all-offices', function(e) {
            e.preventDefault();

            $('.office-profile__map-addresses').addClass('office-profile__map-addresses--show');
        })
        .on('click', '.js-show-more-people', function (e) {
            e.preventDefault();

            $(this).parent().hide();
            $('.office-profile__person__item').show();
        })
        .on('click', '.js-open-profile-modal', function (e) {
            e.preventDefault();

            $($(this).attr('href')).fadeIn();
        })
        .on('click', '.js-close-profile-modal', function (e) {
            e.preventDefault();

            $('.js-profile-modal').fadeOut();
        })
        .on('click', '#legal-services [data-toggle="tab"]', function (e) {
            e.preventDefault();

            var $legalServices = $('#legal-services');
            var $tabs = $legalServices.find('[data-toggle="tab"]');
            var $panes = $legalServices.find('.tabbed-panels__pane');
            var $this = $(this);
            var target = $this.attr('href');
            var $target = $(target);

            $tabs.removeClass('active');
            $this.addClass('active');

            $panes.removeClass('active');
            $target.addClass('active');
        });


    onVimeoIframeAPIReady();
    loadYouTubeApi();

    $(document).on('slideshowBefore', function () {
        var $vimeoMedia = $('.slideshow--media .oembed-provider-Vimeo');
        var $youTubeMedia = $('.slideshow--media .oembed-provider-YouTube');

        if ($vimeoMedia.length > 0) {
            $vimeoMedia.each(function() {
                var player = $(this).closest('.slideshow__slides__slide').data('player');

                if (player && typeof player.pause == 'function') {
                    player.pause();
                }
            });
        }

        if ($youTubeMedia.length > 0) {
            $youTubeMedia.each(function() {
                var player = $(this).closest('.slideshow__slides__slide').data('player');

                if (player && typeof player.pauseVideo == 'function') {
                    player.pauseVideo();
                }
            });
        }
    });

    $(window).resize(function() {
        var $addresses = $('.office-profile__map-addresses__scroll');

        if ($addresses.length > 0) {
            var w = $(window).width();
            var spacing = Math.round((w - $('.core:first').outerWidth()) / 2);

            if (spacing < 0) {
                spacing = 0;
            }

            spacing += 20;

            $addresses.find('ul').css({
                'width': ((255 * $addresses.find('li').length) + (spacing * 2)) + 'px',
                'padding-right': spacing+'px',
                'padding-left': spacing+'px'
            });
        }
    }).trigger('resize');

})(jQuery);

function officeProfileLocationMap() {
    try{
        var $map = $('#location-map');
        var latLng = new google.maps.LatLng($map.data('latitude'), $map.data('longitude'));
        var map = new google.maps.Map($map.get(0), {
            center: latLng,
            zoomControl: true,
            disableDefaultUI: true,
            scrollwheel: false,
            zoom: 14
        });
        var marker = new google.maps.Marker({
            map: map,
            position: latLng,
            icon: '/assets/frontend/images/map-pin.png'
        });
    } catch (e){
        console.error("Error loading office profile map: " + e.message);
    }

}

function loadYouTubeApi() {
    var $youTubeMedia = $('.slideshow--media .oembed-provider-YouTube');

    if ($youTubeMedia.length > 0) {
        var firstScriptTag = document.getElementsByTagName('script')[0];
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}

function onYouTubeIframeAPIReady() {
    var $youTubeMedia = $('.slideshow--media .oembed-provider-YouTube');

    $youTubeMedia.each(function(index) {
        var $this = $(this);
        var $slideshow = $this.closest('.slideshow');

        var videoId = 'yt-video-'+index;

        $this.find('iframe').attr('id', videoId);

        player = new YT.Player(videoId, {
            events: {
                'onReady' : function(e) {
                    $(e.target.getIframe()).closest('.slideshow__slides__slide').data('player', e.target);
                },
                'onStateChange': function(e) {
                    var flexslider = $slideshow.data('flexslider');

                    if (flexslider) {
                        if (e.data == YT.PlayerState.PLAYING) {
                            flexslider.flexslider('pause');
                        } else if (e.data == YT.PlayerState.ENDED) {
                            flexslider.flexslider('play');
                        }
                    }
                }
            }
        });
    });
}

function onVimeoIframeAPIReady() {
    var $vimeoMedia = $('.slideshow--media .oembed-provider-Vimeo');

    if ($vimeoMedia.length > 0) {
        $vimeoMedia.each(function() {
            var $this = $(this);
            var $slideshow = $this.closest('.slideshow');
            var player = new Vimeo.Player($this.find('iframe').get(0));

            if (player) {
                $this.closest('.slideshow__slides__slide').data('player', player);

                player.on('play', function() {
                    $slideshow.data('flexslider').flexslider('pause');
                });

                player.on('ended', function() {
                    $slideshow.data('flexslider').flexslider('play');
                });
            }

        });
    }
}

function officeProfileOpenedModalCallback() {
    equalise();
    loadYouTubeApi();
    setupSlideshows();
    officeProfileLocationMap();
    setupAccordions();
    onVimeoIframeAPIReady();

    if (typeof YT == 'object') {
        onYouTubeIframeAPIReady();
    }
}
